import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { putSituationApiCrud, type PutSituationRequest } from "@/generated/fastapi";

export async function putSituation(
  accessToken: string | null | undefined,
  request: PutSituationRequest,
) {
  const response = await putSituationApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to update situation (${response.status})`);
  }

  return response.data;
}
